module.exports = __webpack_public_path__ + "static/media/icon-arrowhead.b3bc40be.svg";